module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAQCAMAAADQzfSkAAAAMFBMVEVMaXGjqb2jqb2jqb2jqb2jqb2jqb2jqb2jqb2jqb2jqb2jqb2jqb2jqb2jqb2jqb28PdHfAAAAD3RSTlMAgBBA8NAwcMCgYOCQsFCc8nu3AAAACXBIWXMAAAsSAAALEgHS3X78AAAAb0lEQVQYlX2RWQ7AIAgFH+BS7cL9b9sQbTVWO59MXtjwwiJEUaRVKlfa9cEfoTO5icL2pHnTL0dRbqJUk7lZyiAgLJQ6gFZO5dfJ0jHgF8oGDfMdPNsSYbxKUwDTGHWx+0Hsu565htqLIhm5nhnADS1nEWFV+oxsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shadow.png
// module id = PZsw
// module chunks = 4